import { Type } from 'class-transformer';

import { PartialType, PickType } from '../codegen';
import { ApiProperty } from '../codegen';
import { BasicEntityWithoutId } from '../modules';
import { IsNumber, IsOptional, IsString, Min } from '../validators';

export class BaseReadAllDto extends PartialType(
  PickType(BasicEntityWithoutId, ['updatedAt']),
) {
  @ApiProperty()
  @IsOptional()
  @IsString()
  cursor?: string;

  @ApiProperty()
  @IsOptional()
  @IsNumber()
  @Min(1)
  @Type(() => Number)
  limit?: number;
}
